var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2593","data-name":"Path 2593","d":"M352.718,387.751a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm.532,3.55a1.26,1.26,0,1,1-.9.353,1.262,1.262,0,0,1,.9-.353Zm-.7,12.849a1.237,1.237,0,0,1-1.662-.976,4.553,4.553,0,0,1,.061-1.181c.6-4.747.627-4.783.592-5.25a.533.533,0,0,0-.43-.489,1.918,1.918,0,0,0-.653.055q.03-.194.061-.387c3.811-1.258,2.82-.95,3.618-1.1-.956,7.778-1.027,7.673-.785,7.84.43.371,1.053-1.024,1.291-1.532l.345.139C354.519,402.465,353.791,403.85,352.545,404.15Z","transform":"translate(-342.718 -387.751)","fill":"#27788c"}));
}

InfoIcon.defaultProps = {"id":"ICON_-_Info","data-name":"ICON - Info","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
